import tpl from '../templates/interactive.jsx';
import {Form} from 'MWComponents';
import Model from '../models/form.m';
import queryParams from '../queries/form.m.q';
import {apiback} from '../../../../../config';

export default class extends Form {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            model: new Model(),
            drag: false,
            setDrag: state => {
                this.setState({drag: state ? state : false});
            },
            selectedFile: '',
            error: false,
            id: window.location.href.split('/').pop(),
            success: false,
            agree: false,
            infChannelActive: false,
            infChannelTouched: false
        };
        this.query = queryParams;
        this._initMethods();
        return this;
    }

    _run(data) {
        const model = this.getModel();
        model.run({name: data.name, value: data.value});
        this.setState({model});
    }

    handleFile(event) {
        const data = {
            name: event.dataTransfer.files[0] ? 'file' : event.target.name,
            value: event.target.files ? event.target.files[0] : event.dataTransfer.files[0]
        };
        const fileName = event.target.value ? event.target.value : event.dataTransfer.files[0].name;
        this._run(data);
        this.changeFirstInput(data.name);
        this.setState({selectedFile: fileName});
    }

    handleChange(event) {
        const data = {
            name: event.target.name,
            value: event.target.files ? event.target.files[0] : event.target.value
        };

        this._run(data);
        if (event.target.files) {
            this.changeFirstInput(data.name);
            this.setState({selectedFile: event.target.files[0].name});
        }
    }

    closeModal(event) {
        event ? event.stopPropagation() : this.props.closeModal();

        const target = event && event.target,
            classesToClose = ['form-wrapper', 'close-btn'];

        if (target && classesToClose.some(className => target.classList.contains(className))) {
            this.props.closeModal();
        }
    }

    onBlurHandle = name => {
        this.changeFirstInput(name);
    };

    changeFirstInput(name) {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    }

    setPhone(event) {
        const {value} = event.target;
        if (!value.length) {
            const data = {
                name: 'phone',
                value: '+380'
            };
            this._run(data);
        }
    }

    handleChannelFocus() {
        this.setState({infChannelActive: true});
    }

    handleChannelBlur(event) {
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) {
            this.setState({infChannelActive: false, infChannelTouched: true});
        }
    }

    handleEscape(event) {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    }

    sendForm = async () => {
        const model = this.getModel();
        const phone = model.fields.phone.value
            .split('')
            .filter(el => el !== ' ')
            .join('');
        const data = {
            phone,
            name: model.fields.name.value,
            surname: model.fields.surname.value,
            email: model.fields.email.value,
            file: model.fields.file.value,
            city: model.fields.city.value,
            vacancy_id: this.state.id,
            url: location.href,
            inf_channel: model.fields.inf_channel.value
        };

        try {
            const corezoidRes = await fetch(apiback('API_COREZOID'), {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    conv_data: {
                        url: location.href,
                        posit: this.props.vacancyName || '',
                        name: data.name,
                        surname: data.surname,
                        source: data.inf_channel,
                        phone: phone.replace(/\D/g, ''),
                        mail: data.email,
                        city: data.city
                    },
                    hash: 'K7Q2M9XR4TBW1ZNA'
                })
            });
            if (!corezoidRes.ok) {
                console.error('[Career] Corezoid request failed:', corezoidRes.status);
            }
        } catch (err) {
            console.error('[Career] Corezoid fetch error:', err);
        }

        const clientData = this.query.create(data);
        fetch(clientData.url, {method: clientData.type, body: clientData.data})
            .then(res => {
                if (res.status === 200) {
                    this.setState({success: true});
                    this._closeTimeout = setTimeout(() => this.props.closeModal(), 3000);
                } else {
                    this.setState({error: true});
                    this.closeMessage();
                }
            })
            .catch(() => {
                this.setState({error: true});
                this.closeMessage();
            });
    };

    closeMessage() {
        this._errorTimeout = setTimeout(() => {
            this.setState({error: false, success: false});
        }, 5000);
    }

    _initMethods() {
        this.closeModal = this.closeModal.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChannelFocus = this.handleChannelFocus.bind(this);
        this.handleChannelBlur = this.handleChannelBlur.bind(this);
        this.onBlurHandle = this.onBlurHandle.bind(this);
        this.setPhone = this.setPhone.bind(this);
        this._run = this._run.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.handleFile = this.handleFile.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEscape);
        clearTimeout(this._closeTimeout);
        clearTimeout(this._errorTimeout);
    }

    static displayName = 'SendForm.Modal.';
}
